import { render, staticRenderFns } from "./CustomerSaleProductList.vue?vue&type=template&id=90f57406&"
import script from "./CustomerSaleProductList.vue?vue&type=script&lang=js&"
export * from "./CustomerSaleProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports